<template>
  <div class="wrapper_questions bg-red">
    <div v-if="node" :class="node.classes">
      <div class="header_question">
        <img
          class="img_cocci_bulle"
          src="../img/coccinelle_bulle.png"
          alt="Image Coccinelle Dargaud"
          width="64px"
        />
        <div class="title">
          {{ node.question }}
        </div>
      </div>

      <ul id="reco_questions" class="liste_choix">
        <li
          v-for="choix in node.answers"
          :key="choix.value"
          @click="
            changeQuestion(choix.next),
              updateState(
                choix.state,
                choix.value,
                choix.offSetFreq,
                choix.range
              )
          "
          :data-value="choix.value"
        >
          {{ choix.label }}
        </li>
      </ul>
    </div>
    <Footer v-if="this.history.length > 0" />
  </div>
</template>

<script>
// import des différentes mutations
import { mapMutations, mapState } from "vuex";
// import JSON, questions, réponses, ID ...
import json from "./../arbre.js";
import Footer from "../components/Footer";
export default {
  data() {
    return {
      selected: null,
      jsonArbre: json
    };
  },
  components: {
    Footer
  },
  computed: {
    ...mapState([
      "current_page",
      "current_question",
      "history",
      "age",
      "genre",
      "freqLecture",
      "typeLecture",
      "oneShot",
      "envieNC",
      "suprise",
      "changeGenre",
      "range",
      "offSet",
      "offSetFreq",
      "scenario",
      // state "rien" pour éviter un undefined a lors de l'appel de la fct updateState
      "rien"
    ]),
    node() {
      return this.jsonArbre.find(branch => branch.id === this.current_question);
    }
  },
  created() {
    this.SET_CPTNEWRES(0);
  },
  // les différentes methodes du store
  methods: {
    ...mapMutations([
      "SET_CURRENTPAGE",
      "SET_CURRENTQUESTION",
      "SET_ADDHISTORY",
      "SET_AGE",
      "SET_GENRE",
      "SET_FREQLECTURE",
      "SET_TYPELECTURE",
      "SET_ONESHOT",
      "SET_ENVIENC",
      "SET_SURPRISE",
      "SET_RANGE",
      "SET_OFFSET",
      "SET_OFFSETFREQ",
      "SET_INITOFFSET",
      "SET_RIEN",
      "SET_SCENARIO",
      "SET_CPTNEWRES"
    ]),
    updateState: function(event, value, offSetFreq, range) {
      // event vient de choix.state, qui donne le nom du state à récupérer dans le fichier JSON
      const mutation = "SET_" + event.toUpperCase();
      // on lance la mutation correspondante au state avec pour parametre la "value" correspondante dans le JSON
      this[mutation](value);
      if (offSetFreq) {
        this.SET_OFFSETFREQ(offSetFreq);
      }
      document.querySelector(".liste_choix").scrollTop = 0;
      // if (value == "proche") {
      //   this.SET_RANGE(5);
      // }
      if (range) {
        this.SET_RANGE(range);
      }
    },
    // au click, changement de la question, on récupère l'id de la prochaine question. "next" dans le fichier JSON
    changeQuestion: function(id) {
      this.SET_CURRENTQUESTION(id);
      // a chaque changement de question, on enregistre son id pour l'historique
      this.SET_ADDHISTORY(id);
      // id = 100, on arive sur le 2eme écran de reco, on propose 5 albums
      // if (id == 100) {
      //   this.SET_RANGE(5);
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
$red: #f52246;

.wrapper_questions {
  position: relative;
  min-height: 100%;
  color: white;
  padding-bottom: 80px;
}

.header_question {
  position: relative;
  z-index: 1;
  padding-top: 90px;
}

.title {
  max-width: 280px;
  margin: 20px auto 40px auto;
  font-size: 22px;
  line-height: 1.36;
  letter-spacing: -0.17px;
  font-weight: bold;
}

// fonds selon questions
.bg-red {
  background-color: $red;
}

// choix des genre, menu "drop down"
.question-genre {
  .liste_choix {
    height: 270px;
    &.open {
      display: block;
    }
    padding-bottom: 0;
    transition: 0.3s ease;

    &:after {
      content: "";
      position: absolute;
      right: 50px;
      width: 16px;
      height: 20px;
      background: url(../img/arrow.svg) no-repeat center / contain;
      opacity: 1;
      transition: all 0.3s ease;
    }

    &:after {
      display: none;
      animation: petitMouvement 1.5s linear infinite;
    }

    &:after {
      position: fixed;
      display: block;
      bottom: 86px;
      left: 50%;
      transform: translate(-50%, 0);
    }

    // animation fleche
    @keyframes petitMouvement {
      0%,
      100% {
        bottom: 84px;
      }

      50% {
        bottom: 88px;
      }
    }
  }
}

// Liste des genres
.wrapper_q_genre {
  &:before {
    content: "";
    position: absolute;
    top: 18px;
    right: 50px;
    width: 16px;
    height: 20px;
    background: url(../img/arrow.svg) no-repeat center / contain;
    opacity: 1;
    transition: all 0.3s ease;
  }
}

/* réponses */
.wrapper_q_genre,
.liste_choix {
  position: relative;
  padding: 0 20px;
  list-style: none;

  li {
    padding: 15px 20px;
    margin-bottom: 18px;
    border: 1px solid white;
    border-radius: 30px;
    font-weight: 600;
    transition: all 0.3s ease;
    cursor: pointer;

    @media (hover: hover) {
      &:hover {
        background-color: white;
        color: $red;
      }
    }

    &:active {
      background-color: white;
      color: $red;
    }
  }
}

.liste_choix {
  height: 270px;
  overflow: auto;
  padding: 0 20px 0 20px;

  li {
    // choix selectionné
    &.highlight {
      background-color: white;
      color: $red;
    }
  }
}
// mini téléphones
@media screen and (max-width: 340px) and (max-height: 570px) {
  .header_question {
    padding-top: 50px;
  }
  .title {
    margin: 20px auto 25px auto;
  }
}
</style>
